import React from "react";
import { ThreeDots } from "react-loader-spinner";

const ConfirmationModal = ({ id, text, onConfirm, onCancel, isLoading }) => {
  return (
    <div
      className="modal fade"
      id={id}
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content">
          <div className="modal-body">
            <h5 className="text-center">{text}</h5>
          </div>
          <div className="justify-content-center modal-footer">
            <button
              type="button"
              className={isLoading ? "theme-button disabled " : "theme-button "}
              onClick={onConfirm}
            >
              {isLoading ? (
                <ThreeDots
                  height="20"
                  width="53"
                  radius="9"
                  color="white"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              ) : (
                "Yes"
              )}
            </button>
            <button
              type="button"
              className="theme-button bg-grey mx-3 w-35"
              data-bs-dismiss="modal"
              onClick={onCancel}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
